const FETCH_DETAIL = 'auth/subscriptions/fetch-detail';
const FETCH_DETAIL_SUCCESS = 'auth/subscriptions/fetch-detail-success';
const FETCH_DETAIL_FAILED = 'auth/subscriptions/fetch-detail-failed';
const PAUSE = 'auth/subscriptions/pause';
const PAUSE_SUCCESS = 'auth/subscriptions/pause-success';
const PAUSE_FAILED = 'auth/subscriptions/pause-failed';
const QUANTITY = 'auth/subscriptions/quantity';
const QUANTITY_SUCCESS = 'auth/subscriptions/quantity-success';
const QUANTITY_FAILED = 'auth/subscriptions/quantity-failed';
const FETCH_PRODUCT_DATA = 'auth/subscriptions/fetch-product-data';
const FETCH_PRODUCT_DATA_SUCCESS = 'auth/subscriptions/fetch-product-data-success';
const FETCH_PRODUCT_DATA_FAILED = 'auth/subscriptions/fetch-product-data-failed';
const FETCH_LIST = 'auth/subscriptions/fetch-list';
const FETCH_LIST_SUCCESS = 'auth/subscriptions/fetch-list-success';
const FETCH_LIST_FAILED = 'auth/subscriptions/fetch-list-failed';
const SUBSCRIPTION_ADDRESS_UPDATE = 'auth/subscriptions/subscription-address/update';
const SUBSCRIPTION_ADDRESS_RESET = 'auth/subscriptions/subscription-address/reset';
const SUBSCRIPTION_ADDRESS_SAVE = 'auth/subscriptions/subscription-address/save';
const SUBSCRIPTION_ADDRESS_SAVE_FAILED = 'auth/subscriptions/subscription-address/save-failed';
const SUBSCRIPTION_ADDRESS_SAVE_SUCCESS = 'auth/subscriptions/subscription-address/save-success';
const SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE = 'auth/subscriptions/subscription-address/set-is-edit-mode';
const SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN = 'auth/subscriptions/subscription-address/is-modal-open';
const fetchDetail = (payload)=>({
        type: FETCH_DETAIL,
        payload
    })
;
const fetchDetailSuccess = (payload)=>({
        type: FETCH_DETAIL_SUCCESS,
        payload
    })
;
const fetchDetailFailed = (error)=>({
        type: FETCH_DETAIL_FAILED,
        error
    })
;
const pause = (payload)=>({
        type: PAUSE,
        payload
    })
;
const pauseSuccess = (payload)=>({
        type: PAUSE_SUCCESS,
        payload
    })
;
const pauseFailed = (error)=>({
        type: PAUSE_FAILED,
        error
    })
;
const quantity = (payload)=>({
        type: QUANTITY,
        payload
    })
;
const quantitySuccess = (payload)=>({
        type: QUANTITY_SUCCESS,
        payload
    })
;
const quantityFailed = (payload)=>({
        type: QUANTITY_FAILED,
        payload
    })
;
const fetchProductData = (payload)=>({
        type: FETCH_PRODUCT_DATA,
        payload
    })
;
const fetchProductDataSuccess = (payload)=>({
        type: FETCH_PRODUCT_DATA_SUCCESS,
        payload
    })
;
const fetchProductDataFailed = (payload)=>({
        type: FETCH_PRODUCT_DATA_FAILED,
        payload
    })
;
const fetchList = ()=>({
        type: FETCH_LIST
    })
;
const fetchListSuccess = (payload)=>({
        type: FETCH_LIST_SUCCESS,
        payload
    })
;
const fetchListFailed = (error)=>({
        type: FETCH_LIST_FAILED,
        error
    })
;
const updateSubscriptionAddress = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_UPDATE,
        payload
    })
;
const resetSubscriptionAddress = ()=>({
        type: SUBSCRIPTION_ADDRESS_RESET
    })
;
const saveSubscriptionAddress = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SAVE,
        payload
    })
;
const saveSubscriptionAddressSuccess = ()=>({
        type: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS
    })
;
const saveSubscriptionAddressFailed = (error)=>({
        type: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
        error
    })
;
const setSubscriptionFormIsModalOpen = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
        payload
    })
;
const setSubscriptionFormIsEditMode = (payload)=>({
        type: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
        payload
    })
;

export { FETCH_DETAIL, FETCH_DETAIL_FAILED, FETCH_DETAIL_SUCCESS, FETCH_LIST, FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_PRODUCT_DATA, FETCH_PRODUCT_DATA_FAILED, FETCH_PRODUCT_DATA_SUCCESS, PAUSE, PAUSE_FAILED, PAUSE_SUCCESS, QUANTITY, QUANTITY_FAILED, QUANTITY_SUCCESS, SUBSCRIPTION_ADDRESS_RESET, SUBSCRIPTION_ADDRESS_SAVE, SUBSCRIPTION_ADDRESS_SAVE_FAILED, SUBSCRIPTION_ADDRESS_SAVE_SUCCESS, SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE, SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN, SUBSCRIPTION_ADDRESS_UPDATE, fetchDetail, fetchDetailFailed, fetchDetailSuccess, fetchList, fetchListFailed, fetchListSuccess, fetchProductData, fetchProductDataFailed, fetchProductDataSuccess, pause, pauseFailed, pauseSuccess, quantity, quantityFailed, quantitySuccess, resetSubscriptionAddress, saveSubscriptionAddress, saveSubscriptionAddressFailed, saveSubscriptionAddressSuccess, setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen, updateSubscriptionAddress };
//# sourceMappingURL=actions.js.map
